"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Promise = void 0;
var Promise = window.Promise;
exports.Promise = Promise;

window.hubspot.require(['q'], function (Q) {
  exports.Promise = Promise = Q.Promise;
});